module.exports = __webpack_public_path__ + "img/onlink_to_f62c6k.79f834da.svg";